import React from "react"
// import navbarState from "../Global/Navbar"

export default function TeamPhoto({ src1, src2, src3 }) {
  // const b1 = document.getElementsByTagName("div1")
  // const b2 = document.getElementsByTagName("div2")

  return (
    // <section className="my-4 section py-4">
    //   <div className="container">
    //     <div className="row py-5 mt-5 mb-3">
    //       <div className="col-10 col-sm-8 mx-auto text-left">
    //         <img src={src1} class="border-circle" width="300px" alt="..." />
    //       </div>
    //       <div className="col-6 col-sm-4 mt-4 text-center">
    //         <h4 className="title text-success mt-5">aashish paliwal</h4>
    //         <p className="lead">
    //           Lorem ipsum dolor sit, amet consectetur adipisicing elit. Eveniet,
    //           illo! A, consectetur ullam veniam explicabo suscipit tempore
    //           perspiciatis perferendis nesciunt.
    //         </p>
    //       </div>

    //       <div className="col-6 col-sm-4 mt-5 text-center">
    //         <h4 className="title text-success mt-5">mohan paliwal</h4>
    //         <p className="lead">
    //           Lorem ipsum dolor sit, amet consectetur adipisicing elit. Eveniet,
    //           illo! A, consectetur ullam veniam explicabo suscipit tempore
    //           perspiciatis perferendis nesciunt.
    //         </p>
    //       </div>

    //       <div className="col-10 col-sm-8 mx-auto mt-5 text-right">
    //         <img src={src2} class="border-circle" width="300px" alt="..." />
    //       </div>
    <div className="row mb-3 py-3">
      <div className="div col-10 col-sm-10 mx-auto">
        <div class="card-group">
          <div class="card col-10 col-xs-8 col-sm-10 col-md-8 col-lg-4 bg-dark mr-2 border-success">
            <img src={src1} class="card-img-top2" alt="..." />
            <div class="card-body">
              <h5 class="card-title text-success">Mohan Paliwal</h5>
              <p class="card-text text-white">
                This is a wider card with supporting text below as a natural
                lead-in to additional content. This content is a little bit
                longer.
              </p>
            </div>
            <div class="card-footer">
              <small class="text-muted">Last updated 3 mins ago</small>
            </div>
          </div>
          <div class="card col-10 col-xs-8 col-sm-10 col-md-8 col-lg-4 bg-dark mr-2 border-success">
            <img src={src2} class="card-img-top2" alt="..." />
            <div class="card-body">
              <h5 class="card-title text-success">Pooja Paliwal</h5>
              <p class="card-text text-white">
                This card has supporting text below as a natural lead-in to
                additional content.
              </p>
            </div>
            <div class="card-footer">
              <small class="text-muted">Last updated 3 mins ago</small>
            </div>
          </div>
          <div class="card col-10 col-xs-8 col-sm-10 col-md-8 col-lg-4 bg-dark mr-2 border-success">
            <img src={src3} class="card-img-top2" alt="..." />
            <div class="card-body">
              <h5 class="card-title text-success">Geeta Paliwal</h5>
              <p class="card-text text-white">
                This is a wider card with supporting text below as a natural
                lead-in to additional content. This card has even longer content
                than.
              </p>
            </div>
            <div class="card-footer">
              <small class="text-muted">Last updated 3 mins ago</small>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
